<template>
<v-card>
    <v-app-bar v-if="!headerHide" flat dense color="white">
        <div v-if="headingicon">
            <slot name="widget-header-titleicon">
                <div class="header-icon-space ">
                    <v-icon>{{ titleicon }}</v-icon>
                </div>
            </slot>
        </div>

        <v-toolbar-title class="mx-auto">
            {{ title }}
        </v-toolbar-title>
        <v-spacer />
        <slot name="widget-header-action" v-if="headingendicon">
            <v-btn icon>
                <v-icon>{{ icon }}</v-icon>
            </v-btn>
        </slot>

        <v-dialog
      v-model="dialog"
      scrollable
      width="600px"
      v-if="helpicon"
       
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on" 
        >
          <v-icon>mdi-help</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text">About {{helpheading}}</span>
        </v-card-title>
        <v-card-text>
          <slot name="help-content" />
       
        </v-card-text>
       <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
         
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-app-bar>
    <v-divider v-if="!headerHide" />

    <v-card-text v-if="!paddingHide">
        <slot name="widget-content" />
    </v-card-text>
    <slot v-else name="widget-content" />

</v-card>
</template>

<script>
export default {
    name: 'AppWidget',
    props: {
        title: {
            type: String,
            default: '',
        },
        helpcontent: {
            type: String,
            default: '',
        },
        helpheading: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: 'mdi-dots-vertical',
        },
        titleicon: {
            type: String,
            default: 'mdi-dots-vertical',
        },
        headerHide: Boolean,
        paddingHide: Boolean,
        headingicon: Boolean,
        headingendicon: Boolean,
        helpicon: Boolean,
    },
    data() {
        return {
            dialog: false,
            items: [{
                    title: 'Home',
                    icon: 'mdi-view-dashboard'
                },
                {
                    title: 'About',
                    icon: 'mdi-forum'
                },
            ],
        }
    },
};
</script>

<style scoped>
.header-icon-space {
    padding-right: 10px !important;
}
</style>
